import { pageArgs } from '@/utils'
/**
 * 页面参数
 */
const state = {
  // 分享者
  ...pageArgs.args()
}
const getters = {
  sourceUserId: state => state.sourceUserId,
  userId: state => state.userId,
  id: state => state.id, // 家庭卡承诺书id
  cardId: state => state.cardId,
  teacherId: state => state.teacherId,
  goodsIds: state => state.goodsIds,
  shareCode: state => state.shareCode, // 分享信息编码
  contentNo: state => state.contentNo,
  test: state => state.test,
  fromIntegral: state => (state.fromSrc && state.fromSrc === 'integral') || false, // 判断来源是否为积分商城
  fromLogin: state => (state.fromSrc && state.fromSrc === 'login') || false // 判断来源是否必须登录
}

const mutations = {}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
